module.exports = __webpack_public_path__ + "img/5.aae0f121.png";